var map = {
	"./App": 2827,
	"./App.vue": 2827,
	"./assets/button.scss": 77760,
	"./assets/font/Montserrat-Bold.ttf": 19034,
	"./assets/font/Montserrat-Medium.ttf": 67738,
	"./assets/font/Montserrat-SemiBold.ttf": 89804,
	"./assets/images/bg-kv-5.jpg": 40676,
	"./assets/images/bg-map.png": 22071,
	"./assets/images/bg-pricing.png": 95063,
	"./assets/images/card.png": 44697,
	"./assets/images/card@2x.png": 19323,
	"./assets/images/card@3x.png": 78160,
	"./assets/images/chain": 75278,
	"./assets/images/chain/": 75278,
	"./assets/images/chain/arbitrum.png": 28195,
	"./assets/images/chain/avalanche.png": 7866,
	"./assets/images/chain/ban.png": 10534,
	"./assets/images/chain/bsc.png": 18489,
	"./assets/images/chain/ethereum.png": 69502,
	"./assets/images/chain/index": 75278,
	"./assets/images/chain/index.js": 75278,
	"./assets/images/chain/optimism.png": 97767,
	"./assets/images/chain/polygon.png": 43247,
	"./assets/images/change.png": 93931,
	"./assets/images/cloud-computing.png": 58041,
	"./assets/images/cloud-computing@2x.png": 71355,
	"./assets/images/cloud-computing@3x.png": 95568,
	"./assets/images/currency": 21934,
	"./assets/images/currency/": 21934,
	"./assets/images/currency/bch.png": 29264,
	"./assets/images/currency/bnb.png": 78405,
	"./assets/images/currency/bsv.png": 83790,
	"./assets/images/currency/btc.png": 83714,
	"./assets/images/currency/coin.svg": 46630,
	"./assets/images/currency/eth.png": 38766,
	"./assets/images/currency/index": 21934,
	"./assets/images/currency/index.js": 21934,
	"./assets/images/currency/no-coin.png": 21106,
	"./assets/images/currency/usd.png": 12751,
	"./assets/images/currency/usdc.png": 37460,
	"./assets/images/currency/usdt.png": 94363,
	"./assets/images/event/2023-pw.png": 65957,
	"./assets/images/event/2023-valentine.png": 67538,
	"./assets/images/event/invitation-10x.png": 18595,
	"./assets/images/event/invitation-10x@2x.png": 28589,
	"./assets/images/event/invitation-10x@3x.png": 17826,
	"./assets/images/event/invitation-code-3.png": 5911,
	"./assets/images/feat-3ds.png": 24136,
	"./assets/images/feat-3ds@2x.png": 88240,
	"./assets/images/feat-dao-nft.jpg": 72755,
	"./assets/images/feat-dao-nft@2x.jpg": 32917,
	"./assets/images/feat-fast.jpg": 50012,
	"./assets/images/feat-fast@2x.jpg": 9444,
	"./assets/images/feat-instantly.jpg": 25342,
	"./assets/images/feat-instantly@2x.jpg": 34030,
	"./assets/images/feat-private.png": 14373,
	"./assets/images/feat-private@2x.png": 52271,
	"./assets/images/feat-secure.png": 97897,
	"./assets/images/feat-secure@2x.png": 88619,
	"./assets/images/icons/activity-normal.svg": 28675,
	"./assets/images/icons/angle-down.svg": 87988,
	"./assets/images/icons/angle-right.svg": 57558,
	"./assets/images/icons/close-menu-pb.svg": 87333,
	"./assets/images/icons/equal-arrow-down.svg": 33411,
	"./assets/images/icons/equal-arrow.svg": 59818,
	"./assets/images/icons/exclamation.svg": 91229,
	"./assets/images/icons/globe.svg": 61761,
	"./assets/images/icons/globe_hover.svg": 44642,
	"./assets/images/icons/new-card-disabled.svg": 79156,
	"./assets/images/icons/new-card-hover.svg": 66410,
	"./assets/images/icons/new-card-normal-mobile.svg": 3896,
	"./assets/images/icons/new-card-normal.svg": 98685,
	"./assets/images/icons/search.svg": 30490,
	"./assets/images/icons/up-arrow.svg": 49829,
	"./assets/images/icons/wallet.svg": 8893,
	"./assets/images/kv-product-mobile.png": 73323,
	"./assets/images/kv-product-mobile@2x.png": 32501,
	"./assets/images/kv-product.png": 36102,
	"./assets/images/kv-product@2x.png": 1022,
	"./assets/images/locale-icons": 2068,
	"./assets/images/locale-icons/": 2068,
	"./assets/images/locale-icons/de.png": 77604,
	"./assets/images/locale-icons/de@2x.png": 57972,
	"./assets/images/locale-icons/de@3x.png": 56639,
	"./assets/images/locale-icons/en.png": 4272,
	"./assets/images/locale-icons/en@2x.png": 15064,
	"./assets/images/locale-icons/en@3x.png": 65315,
	"./assets/images/locale-icons/index": 2068,
	"./assets/images/locale-icons/index.js": 2068,
	"./assets/images/locale-icons/ja.png": 62226,
	"./assets/images/locale-icons/ja@2x.png": 87458,
	"./assets/images/locale-icons/ja@3x.png": 69933,
	"./assets/images/locale-icons/ru.png": 22622,
	"./assets/images/locale-icons/ru@2x.png": 66998,
	"./assets/images/locale-icons/ru@3x.png": 65089,
	"./assets/images/locale-icons/tr.png": 85499,
	"./assets/images/locale-icons/tr@2x.png": 58117,
	"./assets/images/locale-icons/tr@3x.png": 63578,
	"./assets/images/locale-icons/zh-cn.png": 86409,
	"./assets/images/locale-icons/zh-cn@2x.png": 61323,
	"./assets/images/locale-icons/zh-cn@3x.png": 3424,
	"./assets/images/locale-icons/zh-tw.png": 30005,
	"./assets/images/locale-icons/zh-tw@2x.png": 71519,
	"./assets/images/locale-icons/zh-tw@3x.png": 21268,
	"./assets/images/logo.png": 82806,
	"./assets/images/logo@2x.png": 4910,
	"./assets/images/logo@3x.png": 99769,
	"./assets/images/merchants/Amazon.png": 35309,
	"./assets/images/merchants/Amazon@2x.png": 87447,
	"./assets/images/merchants/AppStore.png": 72021,
	"./assets/images/merchants/AppStore@2x.png": 2879,
	"./assets/images/merchants/Etsy.png": 21946,
	"./assets/images/merchants/Etsy@2x.png": 91754,
	"./assets/images/merchants/Facebook.png": 3657,
	"./assets/images/merchants/Facebook@2x.png": 36779,
	"./assets/images/merchants/GoogleAds.png": 80156,
	"./assets/images/merchants/GoogleAds@2x.png": 2316,
	"./assets/images/merchants/Microsoft.png": 33205,
	"./assets/images/merchants/Microsoft@2x.png": 60095,
	"./assets/images/merchants/PayPal.png": 90960,
	"./assets/images/merchants/PayPal@2x.png": 37112,
	"./assets/images/merchants/aws.png": 31722,
	"./assets/images/merchants/aws@2x.png": 74586,
	"./assets/images/modals/kv-no-3ds.png": 92762,
	"./assets/images/modals/kv-no-3ds@2x.png": 18986,
	"./assets/images/modals/kv-pending.png": 35551,
	"./assets/images/modals/kv-pending@2x.png": 3025,
	"./assets/images/modals/kv-success.png": 68811,
	"./assets/images/modals/kv-success@2x.png": 8725,
	"./assets/images/modals/kv-top-up-failed.png": 33443,
	"./assets/images/modals/kv-top-up-failed@2x.png": 47117,
	"./assets/images/modals/kv-top-up-received.png": 24089,
	"./assets/images/modals/kv-top-up-received@2x.png": 81691,
	"./assets/images/no-card.png": 99895,
	"./assets/images/online-entertaining.png": 26995,
	"./assets/images/online-entertaining@2x.png": 63933,
	"./assets/images/online-entertaining@3x.png": 73522,
	"./assets/images/online-shopping.png": 98577,
	"./assets/images/online-shopping@2x.png": 43443,
	"./assets/images/online-shopping@3x.png": 18216,
	"./assets/images/pricing-business-program.png": 84489,
	"./assets/images/pricing-business-program@2x.png": 67595,
	"./assets/images/pricing-classic-program.png": 62129,
	"./assets/images/pricing-classic-program@2x.png": 48339,
	"./assets/images/pricing-nft-program.png": 25617,
	"./assets/images/pricing-nft-program@2x.png": 70195,
	"./assets/images/profile.png": 45572,
	"./assets/images/referral.png": 75251,
	"./assets/images/referral@2x.png": 30568,
	"./assets/images/referral@3x.png": 55795,
	"./assets/images/signout.png": 81418,
	"./assets/images/social/fb-hover.svg": 22504,
	"./assets/images/social/fb-normal.svg": 89999,
	"./assets/images/social/medium-hover.svg": 69817,
	"./assets/images/social/medium-normal.svg": 40644,
	"./assets/images/social/telegram-hover.svg": 45793,
	"./assets/images/social/telegram-normal.svg": 99708,
	"./assets/images/social/twitter-hover.svg": 46979,
	"./assets/images/social/twitter-normal.svg": 25882,
	"./assets/images/wallet": 1296,
	"./assets/images/wallet-connect.png": 67577,
	"./assets/images/wallet/": 1296,
	"./assets/images/wallet/avalanche.png": 92790,
	"./assets/images/wallet/bsc.png": 29701,
	"./assets/images/wallet/ethereum.png": 12594,
	"./assets/images/wallet/index": 1296,
	"./assets/images/wallet/index.js": 1296,
	"./assets/images/wallet/metamask.png": 58542,
	"./assets/images/wallet/polygon.png": 81715,
	"./assets/images/wallet/walletconnect.png": 16018,
	"./assets/tailwind.scss": 22704,
	"./assets/transactions.scss": 87461,
	"./components/AvailableCardCount": 61902,
	"./components/AvailableCardCount.vue": 61902,
	"./components/CardItemActivated": 25530,
	"./components/CardItemActivated.vue": 25530,
	"./components/CardItemAddNew": 53460,
	"./components/CardItemAddNew.vue": 53460,
	"./components/CardItemNotActivated": 35515,
	"./components/CardItemNotActivated.vue": 35515,
	"./components/CurrencySelect": 28056,
	"./components/CurrencySelect.vue": 28056,
	"./components/CustomDropdown": 58804,
	"./components/CustomDropdown.vue": 58804,
	"./components/CustomDropdownItem": 90021,
	"./components/CustomDropdownItem.vue": 90021,
	"./components/EventPopper": 11484,
	"./components/EventPopper.vue": 11484,
	"./components/FooterComponent": 57905,
	"./components/FooterComponent.vue": 57905,
	"./components/InvitationCode": 61215,
	"./components/InvitationCode.vue": 61215,
	"./components/LoadingBouncer": 13700,
	"./components/LoadingBouncer.vue": 13700,
	"./components/LocaleSwitcher": 78138,
	"./components/LocaleSwitcher.vue": 78138,
	"./components/MembershipInfo": 81164,
	"./components/MembershipInfo.vue": 81164,
	"./components/NavBar": 76,
	"./components/NavBar.vue": 76,
	"./components/SimplePicture": 97488,
	"./components/SimplePicture.vue": 97488,
	"./components/TransactionHistory": 19819,
	"./components/TransactionHistory.vue": 19819,
	"./components/UnrecordedHistory": 77569,
	"./components/UnrecordedHistory.vue": 77569,
	"./components/UserInfo": 30068,
	"./components/UserInfo.vue": 30068,
	"./components/icons": 67485,
	"./components/icons/": 67485,
	"./components/icons/IconClosePopup": 62219,
	"./components/icons/IconClosePopup.vue": 62219,
	"./components/icons/index": 67485,
	"./components/icons/index.js": 67485,
	"./components/modals": 40775,
	"./components/modals/": 40775,
	"./components/modals/AddCardConfirm": 26337,
	"./components/modals/AddCardConfirm.vue": 26337,
	"./components/modals/AlertSuccess": 30000,
	"./components/modals/AlertSuccess.vue": 30000,
	"./components/modals/AlertTemplate": 55551,
	"./components/modals/AlertTemplate.vue": 55551,
	"./components/modals/Card3DSecure": 64713,
	"./components/modals/Card3DSecure.vue": 64713,
	"./components/modals/CardImage": 5679,
	"./components/modals/CardImage.vue": 5679,
	"./components/modals/InvitationInput": 4715,
	"./components/modals/InvitationInput.vue": 4715,
	"./components/modals/RewardRecord": 8165,
	"./components/modals/RewardRecord.vue": 8165,
	"./components/modals/TopUpComplete": 89873,
	"./components/modals/TopUpComplete.vue": 89873,
	"./components/modals/TopUpFail": 48403,
	"./components/modals/TopUpFail.vue": 48403,
	"./components/modals/TopupWithReward": 87408,
	"./components/modals/TopupWithReward.vue": 87408,
	"./components/modals/WaitingConfirm": 87652,
	"./components/modals/WaitingConfirm.vue": 87652,
	"./components/modals/WaitingTopUpConfirm": 73618,
	"./components/modals/WaitingTopUpConfirm.vue": 73618,
	"./components/modals/index": 40775,
	"./components/modals/index.js": 40775,
	"./components/modals/styles.scss": 82124,
	"./constants": 82341,
	"./constants/": 82341,
	"./constants/abi": 31563,
	"./constants/abi.js": 31563,
	"./constants/arbitrum/mainnet": 55922,
	"./constants/arbitrum/mainnet.json": 55922,
	"./constants/avalanche/mainnet": 85531,
	"./constants/avalanche/mainnet.json": 85531,
	"./constants/avalanche/testnet": 87832,
	"./constants/avalanche/testnet.json": 87832,
	"./constants/index": 82341,
	"./constants/index.js": 82341,
	"./constants/optimism/mainnet": 51434,
	"./constants/optimism/mainnet.json": 51434,
	"./constants/pancakeswap/bnb": 22960,
	"./constants/pancakeswap/bnb.json": 22960,
	"./constants/pancakeswap/bnbt": 24276,
	"./constants/pancakeswap/bnbt.json": 24276,
	"./constants/polygon/mainnet": 74332,
	"./constants/polygon/mainnet.json": 74332,
	"./constants/polygon/testnet": 88243,
	"./constants/polygon/testnet.json": 88243,
	"./constants/uniswap/goerli": 1215,
	"./constants/uniswap/goerli.json": 1215,
	"./constants/uniswap/holesky": 50424,
	"./constants/uniswap/holesky.json": 50424,
	"./constants/uniswap/mainnet": 10267,
	"./constants/uniswap/mainnet.json": 10267,
	"./constants/uniswap/sepolia": 35726,
	"./constants/uniswap/sepolia-tmp": 59570,
	"./constants/uniswap/sepolia-tmp.json": 59570,
	"./constants/uniswap/sepolia.json": 35726,
	"./i18n": 64147,
	"./i18n.js": 64147,
	"./locales/de": 95894,
	"./locales/de.json": 95894,
	"./locales/en": 44174,
	"./locales/en.json": 44174,
	"./locales/ja": 87980,
	"./locales/ja.json": 87980,
	"./locales/tr": 79755,
	"./locales/tr.json": 79755,
	"./locales/zh-cn": 22651,
	"./locales/zh-cn.json": 22651,
	"./locales/zh-tw": 71587,
	"./locales/zh-tw.json": 71587,
	"./main": 51406,
	"./main.js": 51406,
	"./mock/cards": 89735,
	"./mock/cards.json": 89735,
	"./mock/pending-transaction": 87330,
	"./mock/pending-transaction.json": 87330,
	"./mock/transaction": 6688,
	"./mock/transaction.json": 6688,
	"./router": 39325,
	"./router/": 39325,
	"./router/index": 39325,
	"./router/index.js": 39325,
	"./store": 55129,
	"./store/": 55129,
	"./store/card.module": 90265,
	"./store/card.module.js": 90265,
	"./store/index": 55129,
	"./store/index.js": 55129,
	"./store/modal.module": 78720,
	"./store/modal.module.js": 78720,
	"./store/network.config": 77859,
	"./store/network.config.js": 77859,
	"./store/wallet.module": 71824,
	"./store/wallet.module.js": 71824,
	"./utils/api/card": 77850,
	"./utils/api/card.js": 77850,
	"./utils/currency-helper": 55119,
	"./utils/currency-helper.js": 55119,
	"./utils/format": 78870,
	"./utils/format.js": 78870,
	"./utils/loading": 65110,
	"./utils/loading/": 65110,
	"./utils/loading/index": 65110,
	"./utils/loading/index.js": 65110,
	"./utils/loading/style.scss": 77594,
	"./utils/log": 41363,
	"./utils/log.js": 41363,
	"./utils/mixins": 23707,
	"./utils/mixins.js": 23707,
	"./utils/request": 35720,
	"./utils/request.js": 35720,
	"./views/CardList": 63424,
	"./views/CardList.vue": 63424,
	"./views/CardView": 33013,
	"./views/CardView.vue": 33013,
	"./views/HomeView": 64256,
	"./views/HomeView.vue": 64256,
	"./views/NotFound": 18961,
	"./views/NotFound.vue": 18961,
	"./views/TopUpView": 75738,
	"./views/TopUpView.vue": 75738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;